// extracted by mini-css-extract-plugin
export default {"main":"SubscriptionCancellationsBrowseEditor_main__3xLLr","itemList":"SubscriptionCancellationsBrowseEditor_itemList__2c2l-"};